import { useContext } from 'react';
import { SmartReplyContext, SmartReplyContextData } from './smartReplyContext';
import { SmartReplyPromptPreset } from './smartReplyPromptTypes';

/**
 * Organized pre-generated prompt ideas by type, and a function to get a prompt by key
 */
type UseSmartReplyPromptPresetsData = {
    writePrompts: SmartReplyPromptPreset[];
    editPrompts: SmartReplyPromptPreset[];
    getByKey: SmartReplyContextData['getByKey'];
};

/**
 * Hook to get the pre-generated prompt ideas by type, and a function to get a prompt by key
 */
export function useSmartReplyPromptPresets(): UseSmartReplyPromptPresetsData {
    const { prompts, getByKey } = useContext(SmartReplyContext);
    const writePrompts = prompts.filter((prompt) => prompt.action == 'WRITE');
    const editPrompts = prompts.filter((prompt) => prompt.action == 'EDIT');
    return { writePrompts, editPrompts, getByKey };
}
